module.exports = __webpack_public_path__ + "static/media/mayor_framed2.4972e119.png";